export function createDriverDocumentClient(transport) {
    return {
        /**
         * List tenant-scoped driver document metadata
         *
         * Requires scope: driver-document:read
         */
        getDriversDocuments(driverId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/documents`,
                options,
            });
        },
        /**
         * Get document metadata
         *
         * Requires scope: driver-document:read
         */
        getDriversDocuments2(driverId, documentId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/documents/${encodeURIComponent(documentId)}`,
                options,
            });
        },
        /**
         * Create or revise metadata
         *
         * Requires scope: driver-document:write
         */
        putDriversDocuments(driverId, documentId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/documents/${encodeURIComponent(documentId)}`,
                body,
                options,
            });
        },
        /**
         * List immutable verification decisions
         *
         * Requires scope: driver-document:read
         */
        getDriversDocumentsVerificationDecisions(driverId, documentId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/documents/${encodeURIComponent(documentId)}/verification-decisions`,
                options,
            });
        },
        /**
         * Append verification decision
         *
         * Requires scope: driver-document:verify
         */
        postDriversDocumentsVerificationDecisions(driverId, documentId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/documents/${encodeURIComponent(documentId)}/verification-decisions`,
                body,
                options,
            });
        },
        /**
         * Answer whether this document may be part of an approved onboarding
         *
         * Requires scope: driver-document:eligibility
         */
        getTenantsReferencesEligibility(tenantId, referenceId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/references/${encodeURIComponent(referenceId)}/eligibility`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=driver-document.js.map